import styled, { css } from 'styled-components'

interface ModalOverlayProps {
  foreground?: boolean;
  hasAnnouncementBar?: boolean;
  scrollDirection?: 'up' | 'down';
  isOpen?: boolean;
  theme: {
    rem: (value: number) => string;
    layers: {
      overlay: string;
    };
    mediaQuery: {
      md: (styles: string) => string;
      lg: (styles: string) => string;
    };
  };
}

export const ModalOverlay = styled.div<ModalOverlayProps>`
  width: 100vw;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: rgba(0, 0, 0, 0.6);
  position: fixed;
  left: 0;
  opacity: 0;
  visibility: hidden;
  z-index: ${({ theme, foreground }) => foreground ? '1000' : theme.layers.overlay};
  transition: opacity 0.2s ease-in-out, visibility 0.2s ease-in-out;
  overflow-y: scroll;

  ${({ theme, hasAnnouncementBar, scrollDirection }) => hasAnnouncementBar && scrollDirection !== 'down' ? css`
    height: calc(100dvh - ${theme.rem(136)});
    top: ${theme.rem(136)};

    ${theme.mediaQuery.md(`
      height: calc(100dvh - ${theme.rem(144)});
      top: ${theme.rem(144)};
    `)}

    ${theme.mediaQuery.lg(`
      height: calc(100dvh - ${theme.rem(168)});
      top: ${theme.rem(168)};
    `)}
  ` : css`
    height: calc(100dvh - ${theme.rem(72)});
    top: ${theme.rem(72)};
    
    ${theme.mediaQuery.md(`
      height: calc(100dvh - ${theme.rem(104)});
      top: ${theme.rem(104)};
    `)}

    ${theme.mediaQuery.lg(`
      height: calc(100dvh - ${theme.rem(128)});
      top: ${theme.rem(128)};
    `)}
  `}

  ${({ theme, scrollDirection }) => scrollDirection === 'down' && css`
    ${theme.mediaQuery.md(`
      height: calc(100dvh - ${theme.rem(96)});
      top: ${theme.rem(96)};
    `)}
  `}

  ${({ foreground }) => foreground && css`
    height: 100dvh;
    top: 0;
  `}
  
  ${({ theme, foreground }) => foreground && theme.mediaQuery.md(`
    height: 100dvh;
    top: 0;
  `)}

  ${({ theme, foreground }) => foreground && theme.mediaQuery.lg(`
    height: 100dvh;
    top: 0;
  `)}

  ${({ isOpen }) => isOpen && css`
    opacity: 1;
    visibility: visible;
  `}
`
